var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import RequiredMixin from "../../../components/renderHeader/RequiredMixin";
var PrintHead = (function (_super) {
    __extends(PrintHead, _super);
    function PrintHead() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({
            type: Object
        })
    ], PrintHead.prototype, "configModel", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], PrintHead.prototype, "fontSizeList", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], PrintHead.prototype, "yesOrNoList", void 0);
    __decorate([
        Prop({
            type: Boolean
        })
    ], PrintHead.prototype, "readonly", void 0);
    PrintHead = __decorate([
        Component({
            mixins: [RequiredMixin],
        })
    ], PrintHead);
    return PrintHead;
}(Vue));
export default PrintHead;
